import { Flag } from "@comparaonline/ui-offer-card";
import React from "react";

import { PRODUCT_DETAIL_HEADER_ID_CONTAINER } from "../../../../../constants";
import { Attribute } from "./Attribute";
import { Button } from "./Button";
import { Logo } from "./Logo";
import { Rating } from "./Rating";
import { Styles, withStyles } from "./styles";
import { Title } from "./Title";
import { HeaderProps } from "./types";

const BaseHeader: React.FC<HeaderProps & Styles> = ({
  attributeProps,
  ctaProps,
  imageProps,
  ratingProps,
  flagProps,
  showCtaButton,
  classes
}) => (
  <div className={classes.mainContainer} data-id={PRODUCT_DETAIL_HEADER_ID_CONTAINER}>
    {flagProps && <Flag {...flagProps} />}
    <div className={classes.infoContainer}>
      <div className={classes.logoRating}>
        <Logo {...imageProps} />
        {ratingProps && <Rating {...ratingProps} />}
      </div>
      <div>
        <Title />
        {attributeProps && <Attribute {...attributeProps} />}
      </div>
    </div>
    {showCtaButton && (
      <div className={classes.ctaButtonContainer}>
        <Button {...ctaProps} />
      </div>
    )}
  </div>
);

BaseHeader.defaultProps = {
  showCtaButton: false
};

export const Header = withStyles(BaseHeader);
